import products from '@/storage/products'
import stores from '@/storage/stores'
import { cartBus } from '@/event/cartBus'
import { urlGetProduct } from '@/api/endpoint'
import { fetchPostAuthorizationCsrf } from './fetch/fetchPostAuthorizationCsrf'

function removeBlockedProductsFromCart(blockedProductIds: number[]): void {
  if (blockedProductIds.length === 0) {
    return
  }

  const productIdsInCart = cartBus.value.map((item) => item.product_id)
  const validBlockedIds = blockedProductIds.filter((id) => productIdsInCart.includes(id))

  if (validBlockedIds.length === 0) {
    return
  }

  cartBus.value = cartBus.value.filter((item) => !validBlockedIds.includes(item.product_id))
}

export async function getProductToCategory(categoryIdArray: Array<number>) {
  try {
    const data = {
      category_id_array: categoryIdArray,
      store_id: stores.getStoresData().store_id,
      store_name: stores.getStoresData().name
    }
    const responseProduct = await fetchPostAuthorizationCsrf(urlGetProduct, data)

    if (responseProduct.class === 'success') {
      const fetchData = await responseProduct.data
      products.setProductData(fetchData.product)



      if (fetchData.product_blocked && Array.isArray(fetchData.product_blocked)) {
        await removeBlockedProductsFromCart(fetchData.product_blocked)
      }
    }
  } catch (e) {
    return
  }
}
